import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './addNewLocation.scss';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import CloseIcon from '@/assets/steam/close.svg'
import { showNotification } from '@/utils/notificationUtils';
import DatePicker, { DayValue, DayRange, Day } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import { default as ReactSelect, components } from 'react-select';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { City, State } from '../types/indes';
import Dropdown from 'react-bootstrap/Dropdown';
import { useGetCityList, useGetManagerList } from '../api/getRefrences';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAddCityMutation, useUpdateStateMutation} from '../api/addCity';
import { ModalFooter } from 'react-bootstrap';
import { SelectedManagers } from './SelectedManagers';
import { useDeleteCity } from '../api/deleteCity';
import { useGetLocationDetails } from '../api/getLocations';

const AddNewLocation: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    states?: any;
    role?: any;
    editLocationData?: any;
}> = ({ onClose, onConfirm, open, states, role, editLocationData,  }) => {
    const { user } = useAuth();
    const [selectedCity, setSelectedCity] = useState<State[]>();
    const [selectedRole, setSelectedRole] = useState<any>()
    const [phone, setPhone] = useState('');
    const [cityData, setNewCityData] = useState<string>('');
    const useGetCityMutation = useGetCityList();
    const useCityMutations = useAddCityMutation();
    const useUpdateStateMutations = useUpdateStateMutation();
    const useGetManagerMutation = useGetManagerList();
    const [city, setCity] = useState<City[]>([]);
    const [alreadyAddedCity, setAlreadyAddedCityData] = useState<City[]>([]);
    
    const [newCityDetails, setNewCityDetails] = useState<any[]>([]);
    const [deletedCity, setDeletedCity] = useState<any[]>([]);
    const useDeleteCityMutation = useDeleteCity();
    const [stateName, setStateName] = useState<string>('');
    const useGetLocationMutation = useGetLocationDetails();

    useEffect(()=>{
        getLocationDetails(editLocationData?.id)
    },[editLocationData])



    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'city') {
            setNewCityData(event.target.value)
        }
    };

    const handleChangeState = (event: ChangeEvent<HTMLInputElement>) => {
        setStateName(event.target.value)
    };

    

    const addCityAndState = () => {
        if (editLocationData?.name && cityData) {
            const details = {
                stateId: editLocationData?.id,
                name: cityData
            }
            const updatedLocationDetails = [...newCityDetails, details];
            setNewCityDetails(updatedLocationDetails);
            setNewCityData('');
        } else {
            showNotification({
                type: 'info',
                title: 'Please enter city name.',
            });
        }


    }

    const deleteCityAndState = (stateName: any) => {
        if (newCityDetails && newCityDetails.length > 0) {
            const locations = newCityDetails.filter((item: any) => item.name !== stateName)
            setNewCityDetails(locations);
        }
    }


const deleteCityId = async (id:any) =>{
    const res = await useDeleteCityMutation.mutateAsync({
      id
    });
    if (res) {
        getLocationDetails(editLocationData?.id)
        //resetStates();
       // onConfirm();
     // getLocationsList(1, true);
    }
  }

  const getLocationDetails = async (id:any) =>{
    if(id){
        const res = await useGetLocationMutation.mutateAsync({
            id
          });
          if (res) {
              setStateName(res?.locationDetail?.name)
              setAlreadyAddedCityData(res?.locationDetail?.city)
          }
    }
 
  }

  



    const resetStates = () => {
        setCity([]);
        setPhone('')
        setSelectedCity([]);
        setNewCityDetails([]);
        setSelectedRole('');
        setNewCityData('');

    }


    const getContent = () => {
        return (
            <div className="add-location-content">
                <div className="user-container">
                    <h1>
                        State <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'State name'}
                            onChange={handleChangeState}
                            value={stateName}
                            id="name"
                            //disabled={true}
                        />
                    </div>
                    {/* <div className="new-figma-phone">
                        <PhoneInput
                            placeholder="phone no"
                            value={phone}
                            onChange={setPhone}
                            country={'in'}
                            countryCodeEditable={false}
                        />
                    </div> */}

                </div>

                <div className="user-container mt-3 location-city-mapping">
                    <h1>
                        City <span>*</span>
                    </h1>
                </div>
                <div className='city-mapping'>
                    {alreadyAddedCity  && alreadyAddedCity.length > 0 &&   alreadyAddedCity.sort((a: any, b: any) => a.name.localeCompare(b.name)).map((item: any, index: any) => {
                        return (
                            <div key={index} className={`location-city-map`}>
                                <div className="city">
                                    {item.name} {" "}
                                    <span onClick={() => { deleteCityId(item.id) }}>
                                        <img src={CloseIcon} className='icon' />
                                    </span>
                                </div>
                            </div>
                        )
                    })

                    }
                </div>

                <div className="user-container mt-5 location-city-mapping">
                    <h1>
                        Add new city <span></span>
                    </h1>
                    <div className='addd-city' onClick={() => { addCityAndState() }}>
                        <img src={AddWhiteIcon} />
                    </div>
                </div>

                <div className='rem-mt-5'>
                    <input
                        className={`custome-input`}
                        placeholder={'Enter city name'}
                        onChange={handleChange}
                        value={cityData}
                        id="city"
                    />
                </div>

                <div className='city-mapping mt-3'>
                    {newCityDetails && newCityDetails.length > 0 && newCityDetails.map((item: any, index: any) => {
                        return (
                            <div key={index} className={`location-city-map`}>
                                <div className="city">
                                    {item.name} {" "}
                                    <span onClick={() => { deleteCityAndState(item.name) }}>
                                        <img src={CloseIcon} className='icon' />
                                    </span>
                                </div>
                            </div>
                        )
                    })

                    }
                </div>
            </div>
        );
    };
    return (
        <>
            <Modal
                show={open}
                onHide={() => { resetStates(), onConfirm() }}
                className={`steam-modal-dialog add-location-modal `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {editLocationData ? "Edit location" : 'Add new location'}
                        </div>
                        <div className="modal-header-desc">
                            {''}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <ModalFooter>
                    <div className={`btn-container end`}>
                        <button
                            className={`steam-button button-dark set-height`}
                            onClick={async () => {
                                    await useUpdateStateMutations.mutateAsync({
                                        stateId: editLocationData ? Number(editLocationData?.id) : undefined,
                                        stateName: stateName
                                    });
                                    await useCityMutations.mutateAsync({
                                        stateId: editLocationData ? Number(editLocationData?.id) : undefined,
                                        newCity: newCityDetails
                                    });
                                    resetStates();
                                    onConfirm();
                                
                            }}
                        //disabled={useAddInstituteMutation?.isLoading}
                        >
                            <span>{editLocationData ? "Save" : 'Add User'}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};




export default AddNewLocation;
